/* eslint-disable import/prefer-default-export */
import { AppState } from './Interfaces/AppState';

export const appInitialState: AppState = {
    showLoginErrorMessage: false,
    signUp: {
        currentStep: {
            step: '1',
            details: 'YOUR DETAILS',
        },
        dataUserFromGoogle: {
            photoURL: '',
            uid: null,
            name: '',
            email: '',
        },
        loading: {
            show: false,
            message: '',
        },
        partnerInformationTemporary: {
            partnerName: '',
            CRMURL: '',
            engine: '',
        },
    },
    createAccount: {
        ErrorMessagePayload: {
            show: false,
            message: '',
            activateLinkToLogin: false,
        },
        userData: {
            name: '',
        },
    },
    teamRoster: {
        data: [],
        subscriptionDetails: null,
    },
    settings: {
        typeOfInputsChanged: [],
        wasSomeInputChanged: false,
        wasSomeInputChangedInvalid: false,
        showBilling: false,
        showUpdateCardDetails: false,
        defaultWhitelistedDomains: [],
        whitelistedDomains: [],
        domainsToRemoveFromDB: [],
        restrictedUrlsForWhitelistedDomains: [],
    },
    rubric: {
        currentUserComponent: 0,
    },
    activeRubrics: [],
    addingNewRubric: false,
    selectedRubricId: '',
    creatingSingleAccount: false,
    selectedAssociates: [],
    calibration: {
        showCreateCalibrationForm: false,
        showCreateCalibrationFirstTime: false,
        showOboardingForAdminsThatHasnotCreatedCalibrations: false,
        step: '0',
        showModalAfterCreating: false,
        calibrationId: '',
    },
    editCalibration: {
        selectedEvaluators: [],
    },
};
